import React, { useRef, useEffect } from "react";
import ReactDom from "react-dom";
import axios from "axios";

import "../../index.css";

const Modal = ({ data, setShowModal }) => {
  let sampleAds = data;
  const adsId = data._id;
  // close the modal when clicking outside the modal.
  const modalRef = useRef();
  const closeModal = (e) => {
    if (e.target === modalRef.current) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    incrementAdsView();
  }, []);

  const incrementAdsView = () => {
    try {
      axios
        .get(`${process.env.REACT_APP_BACKEND_API_SERVER}/ads-view/${adsId}`)
        .then(
          (response) => {
            console.log(response.message);
          },
          (error) => {
            alert(error);
          }
        );
    } catch (error) {
      alert(error);
    }
  };

  const incrementAdsClick = () => {
    try {
      axios
        .get(`${process.env.REACT_APP_BACKEND_API_SERVER}/ads-click/${adsId}`)
        .then(
          (response) => {
            console.log(response.message);
          },
          (error) => {
            alert(error);
          }
        );
    } catch (error) {
      alert(error);
    }
  };

  // render the modal JSX in the portal div.
  return ReactDom.createPortal(
    <div className="z-50 container min-w-full" ref={modalRef} onClick={closeModal}>
      <div className="modal lg:w-1/3 md:w-1/2 w-full">
        <div className="text-center">
          {/* <h2 className="m-2.5">Check out this new song!</h2> */}
          <a
            href={sampleAds.songLink}
            onClick={incrementAdsClick}
            target="_blank"
            rel="noreferrer"
          >
            <img src={sampleAds.imgLink} alt={sampleAds.title} />
          </a>
          <button className="bg-blue-600" onClick={() => setShowModal(false)}>
            x
          </button>
        </div>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default Modal;
